import { Component, Inject, OnInit } from '@angular/core';
import { Transition } from '@uirouter/core';

import {
  BASE_PURCHASE_SERVICE,
  BasePurchaseService,
  provideBasePurchaseService,
} from '../../services/base-purchase.service';
import { PurchaseAiCreditsService } from '../../services/purchase-ai-credits.service';
import { PurchaseExitService } from '../../services/purchase-exit.service';
import { PurchaseInteractiveService } from '../../services/purchase-interactive.service';
import { PurchaseStepsService } from '../../services/purchase-steps.service';
import { TaxExemptionService } from '../../services/tax-exemption.service';

export type PurchaseAddOnIntent = 'ai-credits' | 'interactive';

@Component({
  selector: 'purchase-add-on',
  templateUrl: './purchase-add-on.component.html',
  styleUrls: ['./purchase-add-on.component.scss'],
  providers: [
    PurchaseStepsService,
    provideBasePurchaseService({
      aiCredits: PurchaseAiCreditsService,
      interactive: PurchaseInteractiveService,
    }),
  ],
  standalone: false,
})
export class PurchaseAddOnComponent implements OnInit {
  purchaseIntent: PurchaseAddOnIntent;

  constructor(
    private purchaseExitService: PurchaseExitService,
    private transition: Transition,
    @Inject(BASE_PURCHASE_SERVICE)
    public purchaseService: BasePurchaseService,
    public purchaseStepsService: PurchaseStepsService,
    public taxExemptionService: TaxExemptionService,
  ) {
    this.purchaseStepsService.init();
    this.taxExemptionService.init(
      this.purchaseService.getEstimate.bind(this.purchaseService),
    );
  }

  ngOnInit(): void {
    const rawIntent = this.transition.params().purchaseIntent;
    if (rawIntent === 'interactive' || rawIntent === 'ai-credits') {
      this.purchaseIntent = rawIntent;
    } else {
      this.purchaseIntent = 'ai-credits';
    }

    void this.purchaseService.init();
  }

  get isAiCreditsIntent(): boolean {
    return this.purchaseIntent === 'ai-credits';
  }

  get isInteractiveIntent(): boolean {
    return this.purchaseIntent === 'interactive';
  }

  redirect() {
    this.purchaseExitService.exit(this.transition);
  }

  close() {
    if (!this.purchaseService.purchase.reloadingCompany) {
      this.redirect();
    } else {
      this.purchaseService.loading = true;

      this.purchaseService.onCompanyReload(() => {
        this.purchaseService.loading = false;
        this.redirect();
      });
    }
  }
}
